import styled from "styled-components";

export const FooterWrapper = styled.footer`
  padding: 32px 32px 48px;
  background: rgba(204, 187, 184, 0.16);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  border-radius: 56px 56px 0px 0px;
  p,
  a {
    color: #faf8f7;
  }
  @media (max-width: 769px) {
    margin: 0 -24px;
  }
`;

export const FooterDecorWrapper = styled.div`
  position: relative;
  isolation: isolate;
`;

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 769px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24px;
  }
`;

export const FooterSocials = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const FooterLinks = styled.div`
  gap: 32px 64px;
  padding-right: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  button,
  a {
    text-decoration: none;
    letter-spacing: 0.01em;
    border: 0;
    outline: 0;
    background: transparent;
    padding: 0;
    cursor: pointer;
    display: flex;
    gap: 4px;
    align-items: center;
    color: #f2edeb7a;
    transition: 300ms;
    .secondary {
      transition: 300ms;
      &:hover {
        color: #fff;
      }
    }
  }
  @media (max-width: 769px) {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
    margin-top: 6px;
    a {
      padding: 0;
      height: 32px;
    }
  }
`;

export const FooterSocialButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  padding: 2px;
  transition: 300ms ease-out;
  border-radius: var(--rounding-radius-m, 16px);
  background: rgba(204, 187, 184, 0.16);
  // -webkit-backdrop-filter: blur(12px);
  // backdrop-filter: blur(12px);

  &:hover {
    mix-blend-mode: multiply;
  }
  &:active {
    transform: scale(0.95);
  }
  @media (max-width: 769px) {
    border-radius: 16px !important;
    svg {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }
`;
